import React from 'react';
import { createViewConfig } from '@sail/engine';
import { visuallyHidden } from '../utilStyles/visuallyHidden';
export const LabelConfig = createViewConfig({
    props: {},
    name: 'Label',
    flattens: true,
    defaults: {
        as: 'label'
    }
});
export const Label = LabelConfig.createView((props)=>{
    const Element = props.as;
    return /*#__PURE__*/ React.createElement(Element, props);
}, {
    css: {
        color: 'text',
        font: 'label.medium.emphasized'
    },
    variants: {
        hidden: {
            true: visuallyHidden
        }
    }
});

//# sourceMappingURL=Label.js.map